import { render, staticRenderFns } from "./CommCode.vue?vue&type=template&id=5624af48&scoped=true&"
import script from "./CommCode.vue?vue&type=script&lang=js&"
export * from "./CommCode.vue?vue&type=script&lang=js&"
import style0 from "./CommCode.vue?vue&type=style&index=0&id=5624af48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624af48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5624af48')) {
      api.createRecord('5624af48', component.options)
    } else {
      api.reload('5624af48', component.options)
    }
    module.hot.accept("./CommCode.vue?vue&type=template&id=5624af48&scoped=true&", function () {
      api.rerender('5624af48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/CommCode.vue"
export default component.exports